import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { LogTemplateBuilderPage } from 'pages/logbook/LogTemplateBuilderPage'

export const Route = createFileRoute('/logbook/templates/$templateId')({
  component: RouteComponent,
  staticData: {
    title: 'Edit Log Template',
  },
})

function RouteComponent() {
  const { templateId } = Route.useParams()
  const navigate = useNavigate()
  const backToLogbook = () =>
    navigate({ to: '/logbook', search: (prev) => prev })

  return (
    <LogTemplateBuilderPage
      heading='Edit log template'
      submitLabel='Save changes'
      templateId={templateId}
      onSubmit={backToLogbook}
      onCancel={backToLogbook}
    />
  )
}
